<div class="modal-body">
  <div class="content">
    <div class="content__top">
      <h4 translate>reviews.details-popup.title</h4>
      <button type="button" class="close" aria-label="Close" (click)="close()">
        <i class="icon-small-close"></i>
      </button>
    </div>
    <div class="content__main">
      <div class="details-review-table">
        <table>
          <tbody>
            <tr *ngIf="review.company_id">
              <td>
                <span translate>reviews.table.thead.company-id.label</span>
              </td>
              <td>
                <span>{{review.company_id}}</span>
              </td>
            </tr>
            <tr *ngIf="review.title">
              <td>
                <span translate>reviews.table.thead.title.label</span>
              </td>
              <td>
                <span>{{review.title}}</span>
              </td>
            </tr>
            <tr *ngIf="review.reviewer">
              <td>
                <span translate>reviews.table.thead.reviewer.label</span>
              </td>
              <td>
                <span>{{review.reviewer}}</span>
              </td>
            </tr>
            <tr *ngIf="review.platform">
              <td>
                <span translate>reviews.table.thead.platform.label</span>
              </td>
              <td>
                <a class="platform" [href]="review.url" target="_blank">
                  <span
                    [ngClass]="review.platform === 'TRUSTPILOT' ? 'vox-chip vox-chip_royal-blue' : 'vox-chip vox-chip_aquamarine'">{{review.platform}}</span>
                  <i [ngbTooltip]="review.url" class="fa fa-link"></i>
                </a>
              </td>
            </tr>
            <tr *ngIf="review.timestamp">
              <td>
                <span translate>reviews.table.thead.timestamp.label</span>
              </td>
              <td>
                <span>{{review.timestamp | date: 'd.M.y h:mm a': undefined: locale}}</span>
              </td>
            </tr>
            <tr *ngIf="review.rating">
              <td>
                <span translate>reviews.table.thead.rating.label</span>
              </td>
              <td>
                <ngb-rating [rate]="review.rating ? review.rating : 0" [readonly]="true" [max]="5">
                  <ng-template let-fill="fill" let-index="index">
                    <i class="star-rating icon-small-star-outline" [class.icon-small-star]="fill === 100"></i>
                  </ng-template>
                </ngb-rating>
              </td>
            </tr>
            <tr *ngIf="review.notes">
              <td>
                <span translate>reviews.table.thead.notes.label</span>
              </td>
              <td>
                <span>{{review.notes}}</span>
              </td>
            </tr>
            <tr *ngIf="review.cons">
              <td>
                <span translate>reviews.table.thead.cons.label</span>
              </td>
              <td>
                <span>{{review.cons}}</span>
              </td>
            </tr>
            <tr *ngIf="review.pros">
              <td>
                <span translate>reviews.table.thead.pros.label</span>
              </td>
              <td>
                <span>{{review.pros}}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>